import React from "react"
import PropTypes from "prop-types"
import Button from "@material-ui/core/Button"
import SendIcon from "@material-ui/icons/Send"

import { propTypes, containedPrimary } from "./ButtonPropTypes"
import useSmartFormat from "../../i18n/useSmartFormat"
import { words } from "../../i18n/lstrings"

const ButtonSubmit = ({ text, ...props }) => {
  const format = useSmartFormat()
  return (
    <Button type="submit" {...props}>
      {format(text)}
    </Button>
  )
}

ButtonSubmit.propTypes = {
  ...propTypes,
  startIcon: PropTypes.object,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ])
}
ButtonSubmit.defaultProps = {
  ...containedPrimary,
  startIcon: <SendIcon color="inherit" />,
  text: words.submit
}

export default ButtonSubmit
